import * as React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  required,
  SelectInput,
  ReferenceInput,
  AutocompleteInput,
  DateTimeInput
} from "react-admin";

const statusChoices = [
  { id: 'pending', name: 'Pending' },
  { id: 'reserved', name: 'Reserved' },
  { id: 'rented', name: 'Rented' },
  { id: 'returned', name: 'Returned' },
  { id: 'cancelled', name: 'Cancelled' }
];

export const CarRentCreateForm = () => (
  <>
    <SimpleForm>
      <SelectInput source="status" choices={statusChoices} defaultValue="pending" required />
      <TextInput source="name" label="Customer Name" required />
      <TextInput source="phone" label="Phone Number" required />
      <DateTimeInput source="pickUpDate" label="Pick-up Date" required />
      <DateTimeInput source="dropOffDate" label="Drop-off Date" required />

      <ReferenceInput source="carId" reference="car" filter={{ isForRent: true }}>
        <AutocompleteInput optionText="title.en" label="Car Model" />
      </ReferenceInput>
    </SimpleForm>
  </>
);

export const CarCreate = () => (
  <Create>
    <CarRentCreateForm />
  </Create>
);

